import {observer} from 'mobx-react-lite';
import {useState} from 'react';

import {Box, Button, Divider, Grid, Input, Stack, ToggleButton, ToggleButtonGroup, Typography,} from '@mui/material';

const Tariffs = observer(
    ({
         currentTariff,
         patientCount,
         paymentDate,
         paymentList,
         paySumm,
         balance,
         handlePaySummChange,
         handlePayment,
     }) => {
        const [alignment, setAlignment] = useState('individual');

        const handleAlignment = (event, newAlignment) => {
            if (newAlignment !== null && newAlignment !== alignment) {
                setAlignment(newAlignment);
            }
        };

        const calculateRemainingPatients = () => {
            if (!currentTariff) return 0;

            const maxPatients = currentTariff.patientUpperLimit; // Верхний лимит для текущего тарифа
            const remainingPatients = maxPatients - patientCount + 1;

            return remainingPatients > 0 ? remainingPatients : 0;
        };

        return (
            <Box sx={{maxWidth: '4xl', mx: 'auto'}}>
                <Stack spacing={2}>
                    {/* Информация о текущем тарифе */}
                    {currentTariff && (
                        <Box sx={{mb: 2}}>
                            <Typography margin={0} fontSize={'21px'}>
                                <span style={{color: '#A0A0A0'}}>Тариф: </span>V
                                {/*{currentTariff.name}*/}
                                -
                            </Typography>
                            <Typography fontSize={'21px'}>
                                <span style={{color: '#A0A0A0'}}>Пациентов: </span>
                                {patientCount}
                                {/*                <span style={{fontSize: '14px'}}>*/}
                                {/*  {' '}*/}
                                {/*                    (до следующего тарифа {calculateRemainingPatients()} пациентов)*/}
                                {/*</span>*/}
                            </Typography>
                            <Typography fontSize={'21px'}>
                                <span style={{color: '#A0A0A0'}}>День списания: </span>
                                {/*{paymentDate}*/}
                                -
                            </Typography>
                            <Typography fontSize={'21px'}>
                                <span style={{color: '#A0A0A0'}}>На счету: </span>
                                -
                                {/*{balance}₽*/}
                            </Typography>
                        </Box>
                    )}

                    <>
                        {/* Информация о пополнении счета */}
                        <Box width={'450px'}>
                            <Typography fontWeight={400} fontSize={'14px'} mb={1}>
                                Пополняйте счет на любую удобную для вас сумму. Оплата за фактически оказанные
                                услуги производится один раз в конце месяца, в зависимости от количества пациентов.
                            </Typography>
                            <ToggleButtonGroup
                                direction='row'
                                value={alignment}
                                exclusive
                                onChange={handleAlignment}
                                aria-label='alignment'
                                sx={{mb: 3}}
                            >
                                <ToggleButton
                                    value='individual'
                                    aria-label='individual'
                                    variant='outlined'
                                    sx={{mb: 1, fontSize: '0.75rem', height: '35px'}}
                                >
                                    <span style={{color: '#000000'}}>Пополнить как физ. лицо</span>
                                </ToggleButton>
                                <ToggleButton
                                    value='legal'
                                    aria-label='legal'
                                    variant='outlined'
                                    sx={{mb: 1, height: '35px', fontSize: '0.75rem'}}
                                >
                                    <span style={{color: '#000000', fontSize: '12px'}}>Пополнить как юр. лицо</span>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>

                        {/* Строка с оплатой */}
                        <Box sx={{maxWidth: '450px'}}>
                            {alignment === 'individual' ? (
                                <>
                                    <Typography sx={{fontWeight: 'bold', mb: 1}}>Пополнить на:</Typography>
                                    <Stack direction='column' alignItems='start' gap={2}>
                                        <Input
                                            value={paySumm}
                                            onChange={handlePaySummChange}
                                            placeholder='Не менее 1000₽'
                                            type='number'
                                            inputProps={{min: 1000}}
                                            disableUnderline
                                            sx={{
                                                flex: 1,
                                                width: '50%',
                                                borderRadius: '10px',
                                                border: '1px solid #849af1',
                                                padding: '8px',
                                            }}
                                        />
                                        <Button
                                            variant='contained'
                                            onClick={handlePayment}
                                            disabled={!paySumm || paySumm < 1000}
                                            sx={{
                                                height: '35px',
                                                width: '50%',
                                                borderRadius: '10px',
                                                mb: 3.5,
                                                fontSize: '12px',
                                            }}
                                        >
                                            Оплатить
                                        </Button>
                                    </Stack>
                                </>
                            ) : (
                                <>
                                    <Typography fontWeight={400} width={'400px'} fontSize={'14px'} mb={1}>
                                        Для пополнения счета от имени ИП или ООО, пожалуйста, обратитесь к нам в удобном
                                        для вас мессенджере. Мы оперативно подготовим счет для оплаты.
                                    </Typography>
                                    <Box sx={{mb: 5, display: 'flex', gap: '10px'}}>
                                        <a
                                            style={{display: 'block', width: '35px'}}
                                            href='https://wa.me/+79130541446'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            <img
                                                style={{cursor: 'pointer', width: '35px'}}
                                                src={'/icons/whatsapp.svg'}
                                                alt={'Связаться с нами через Whatsapp'}
                                            />
                                        </a>
                                        <a
                                            style={{display: 'block', width: '35px'}}
                                            href='https://t.me/Tola_med'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            <img
                                                style={{cursor: 'pointer', width: '35px'}}
                                                src={'/icons/telegram.svg'}
                                                alt={'Связаться с нами через Telegram'}
                                            />
                                        </a>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </>

                    {/* Список всех тарифов */}
                    <Typography fontSize={'18px'} sx={{fontWeight: 'bold'}}>
                        Тарифы
                    </Typography>
                    <Grid container rowSpacing={1} columnGap={4}>
                        {/*{paymentList.map(*/}
                        {/*    (pr) =>*/}
                        {/*        pr.name !== 'Бесплатный' && (*/}
                        {/*            <Grid item xs={12} sm={6} md={2.5} key={pr.id} sx={{marginBottom: '16px'}}>*/}
                        {/*                <Box*/}
                        {/*                    sx={{*/}
                        {/*                        padding: '16px',*/}
                        {/*                        maxWidth: '320px',*/}
                        {/*                        height: '150px',*/}
                        {/*                        border: '1px solid #849af1',*/}
                        {/*                        backgroundColor: 'transparent',*/}
                        {/*                        display: 'flex',*/}
                        {/*                        flexDirection: 'column',*/}
                        {/*                        justifyContent: 'space-evenly',*/}
                        {/*                        textAlign: 'center',*/}
                        {/*                        borderRadius: '18px',*/}
                        {/*                    }}*/}
                        {/*                >*/}
                        {/*                    <Typography variant='h6' sx={{fontWeight: 400}}>*/}
                        {/*                        {pr.name}*/}
                        {/*                    </Typography>*/}
                        {/*                    <Divider fullWidth color='#849af1'/>*/}
                        {/*                    <Box display={'flex'} flexDirection={'column'} padding={'0'} height={'60%'}>*/}
                        {/*                        <Typography sx={{mb: '5px'}}>*/}
                        {/*                            {pr.patientLowerLimit} - {pr.patientUpperLimit} пациентов*/}
                        {/*                        </Typography>*/}
                        {/*                        <Typography>{pr.pricePerPatient}₽ | за 1 пациента</Typography>*/}
                        {/*                    </Box>*/}
                        {/*                </Box>*/}
                        {/*            </Grid>*/}
                        {/*        )*/}
                        {/*)}*/}
                        <Grid item xs={12} sm={6} md={2.5} key={1} sx={{marginBottom: '16px'}}>
                            <Box
                                sx={{
                                    padding: '16px',
                                    maxWidth: '320px',
                                    height: '150px',
                                    border: '1px solid #849af1',
                                    backgroundColor: 'transparent',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-evenly',
                                    textAlign: 'center',
                                    borderRadius: '18px',
                                }}
                            >
                                <Typography variant='h6' sx={{fontWeight: 400}}>
                                    Лайт
                                </Typography>
                                <Divider fullWidth color='#849af1'/>
                                <Box display={'flex'} flexDirection={'column'} padding={'0'} height={'60%'}>
                                    <Typography sx={{mb: '5px'}}>
                                        101 - 3.000 подписчиков
                                    </Typography>
                                    <Typography>10.990 ₽</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2.5} key={2} sx={{marginBottom: '16px'}}>
                            <Box
                                sx={{
                                    padding: '16px',
                                    maxWidth: '320px',
                                    height: '150px',
                                    border: '1px solid #849af1',
                                    backgroundColor: 'transparent',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-evenly',
                                    textAlign: 'center',
                                    borderRadius: '18px',
                                }}
                            >
                                <Typography variant='h6' sx={{fontWeight: 400}}>
                                    Смарт
                                </Typography>
                                <Divider fullWidth color='#849af1'/>
                                <Box display={'flex'} flexDirection={'column'} padding={'0'} height={'60%'}>
                                    <Typography sx={{mb: '5px'}}>
                                        3.001 - 7.000 подписчиков
                                    </Typography>
                                    <Typography>12.990 ₽</Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={2.5} key={3} sx={{marginBottom: '16px'}}>
                        <Box
                            sx={{
                                padding: '16px',
                                maxWidth: '320px',
                                height: '150px',
                                border: '1px solid #849af1',
                                backgroundColor: 'transparent',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-evenly',
                                textAlign: 'center',
                                borderRadius: '18px',
                            }}
                        >
                            <Typography variant='h6' sx={{fontWeight: 400}}>
                                Про
                            </Typography>
                            <Divider fullWidth color='#849af1'/>
                            <Box display={'flex'} flexDirection={'column'} padding={'0'} height={'60%'}>
                                <Typography sx={{mb: '5px'}}>
                                   Свыше 7.001 подписчика
                                </Typography>
                                <Typography>15.990 ₽</Typography>
                            </Box>
                        </Box>
                    </Grid>


                    </Grid>
                </Stack>
            </Box>
        );
    }
);

export default Tariffs;
